export default {
  add({ commit }, val) {
    commit('ADD', val)
  },
  update({ commit }, val) {
    commit('UPDATE', val)
  },
  clear({ commit }, val) {
    commit('CLEAR', val)
  },

}
